import axios from "axios";

const BASE_URL = "https://petioapi-production.up.railway.app/api/";

export const PublicRequest = axios.create({
  baseURL: BASE_URL,
});
